import { z } from 'zod';

export const outsourcedVendorSchema = z.object({
  _id: z.string(),
  name: z.string(),
  phone: z.string(),
  contactPerson: z.string(),
  createdTime: z.number(),
  updatedTime: z.number(),
})

export type OutsourcedVendor = z.infer<typeof outsourcedVendorSchema>;